import http from './_http'

/**
 * 自动登录，或者手机授权
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const accountLogin = (params) => {
    return http({
        url: '/account/login',
        method: 'post',
        params,
    });
}


/**
 * 注册
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const accountRegister = (params) => {
    return http({
        url: '/account/register',
        method: 'post',
        params,
    });
}
